import { useEffect, useRef } from 'react'

import NewSurvey from '@components/new-survey/NewSurvey'

import { useNewSurvey } from '@context/new-survey/useNewSurvey'
import { trackGetStartedEvent } from '@lib/analytics/get-started-tracking'

import GetStartedPlansConfig from '@config/get-started-plans-config'

import type { GetStartedPlansConfig as GetStartedPlansConfigType } from '@lib/types'
import type { AnnouncementConfig } from '@lib/new-survey/get-new-survey'
import type { GetStartedPageContent } from '@lib/types/get-started-page'
import { FALLBACK_PAGE_CONTENT } from '@lib/types/get-started-page'

type GetStartedSurveyProps = {
	onComplete: () => void
	announcement?: AnnouncementConfig | null
	pageContent?: GetStartedPageContent
}

export default function GetStartedSurvey({ onComplete, announcement, pageContent: pageContentProp }: GetStartedSurveyProps) {
	const pageContent = pageContentProp ?? FALLBACK_PAGE_CONTENT
	const { surveyQuestions } = useNewSurvey() || {}
	const config = GetStartedPlansConfig as GetStartedPlansConfigType
	const questionCount = surveyQuestions?.length || 0
	const hasFiredSurveyStarted = useRef(false)

	useEffect(() => {
		if (hasFiredSurveyStarted.current) return
		hasFiredSurveyStarted.current = true
		trackGetStartedEvent('survey_started')
	}, [])
	// +1 for "Create Account", +1 for "Choose Plan", +1 if checkout step is enabled
	const totalSteps = questionCount + 2 + (config.checkoutStep.enabled ? 1 : 0)

	return (
		<NewSurvey
			callBack={onComplete}
			customFinishText={pageContent.surveyContinueLabel}
			announcement={announcement}
			totalSteps={totalSteps}
		/>
	)
}
